import React from "react";
import COLORS from "../../../colors";

export default function PlusIcon({ fill = COLORS.SECONDARY_COLOR_700 }) {
  return (
    <React.Fragment>
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 0H5V8H3V0Z" fill={fill} />
        <path d="M0 3H8V5H0V3Z" fill={fill} />
      </svg>
    </React.Fragment>
  );
}
